import {PatchEditor} from './PatchEditor.js';

export class Configurator {
    node;
    patchEditor = null;

    choices = {};

    selectedStone;

    translations = {};

    stoneValues = [];

    products = {
        loop: ['size', 'style', 'pattern'],
        inlay: ['style', 'pattern'],
        dogcollar: ['size', 'pattern'],
        belt: ['pattern'],
        bracelet: ['pattern'],
        saddlestrap: ['pattern'],
        patch: ['base-color', 'product-color', 'pattern'],
        crystalnet: ['product-color'],
    };

    preselectedProductValues = {
        inlay: {size: 'long'},
        dogcollar: {style: 'straight'},
        bracelet: {size: 'short', style: 'straight'},
        belt: {size: 'long', style: 'straight'},
        saddlestrap: {size: 'short', style: 'straight'},
    };

    constructor(node) {

        this.node = node;
        let trans = JSON.parse(this.node.querySelector('#translations').dataset.product.replaceAll('=>', ': '));
        for (const [key, value] of Object.entries(trans)) {
            this.translations = {...this.translations, ...value};
        }
        this.setTitle();
        this.initEvents();
        this.initParameters();
    }

    initEvents() {
        this.node.addEventListener('click', (event) => {
            const eventTarget = event.target;

            /* Links with dialogs */
            const linkNode = eventTarget.closest('a');
            if (null !== linkNode) {
                if (true === linkNode.classList.contains('delete-pattern')) {
                    this.resetStones();
                }
            }

            const selectionNode = eventTarget.closest('.step .selection');
            if (null !== selectionNode) {
                this.handleSelection(selectionNode);
            }

            const stoneSelectorNode = eventTarget.closest('.stone_switch .stone');
            if (null !== stoneSelectorNode) {
                this.selectStone(stoneSelectorNode);
            }

            const stoneSlotNode = eventTarget.closest('.stone-slot-trigger');
            if (null !== stoneSlotNode) {
                this.placeStone(stoneSlotNode);
            }

            const breadCrumbNode = eventTarget.closest('.breadcrumb');
            if (null !== breadCrumbNode) {
                this.handleBreadCrumbClick(breadCrumbNode);
            }

            const buttonNode = eventTarget.closest('button');
            if (null !== buttonNode) {
                this.handleButtonClick(buttonNode);
            }
        });
    }

    initParameters(){
        const queryParams = new URLSearchParams(window.location.search);

        let k, v;
        for (const [key, value] of queryParams.entries()) {
            if('stones' === key){
                this.stoneValues = value.split('x');
                continue;
            }
            this.choices[key] = value;
            k = key;
            v = value;
        }

        if (k && v) {
            this.goToStep(k, v);
        }
    }
    handleButtonClick(buttonNode) {
        if (true === buttonNode.classList.contains('close')) {
            buttonNode.closest('.close-target').remove();
        }

    }

    handleBreadCrumbClick(breadCrumbNode) {
        const previousBreadCrumb = breadCrumbNode.previousSibling;

        if (null !== this.patchEditor) {
            this.patchEditor.reset();
            this.patchEditor = null;
        }

        if (null !== previousBreadCrumb) {
            this.goToStep(previousBreadCrumb.dataset.key, previousBreadCrumb.dataset.value);
            return;
        }

        this.reset();
    }

    handleSelection(selectionNode) {
        const step = selectionNode.closest('.step');
        const key = step.dataset.key;
        const value = selectionNode.dataset.value;

        this.goToStep(key, value);
    }

    goToStep(key, value) {
        if (key in this.choices) {
            //This happens when the user clicks on a breadcrumb
            let choiceBackup = this.choices;
            this.choices = {};

            for (let [backupKey, backupValue] of Object.entries(choiceBackup)) {
                if (key === backupKey) {
                    break;
                }

                this.choices[backupKey] = backupValue;
            }
        }

        this.choices[key] = value;
        this.createBreadcrumbs();
        this.createUrl();

        let nextStep = null;
        this.products[this.choices['product']].every((step, index, array) => {
            if (false === step in this.choices) {
                nextStep = step;
                return false;
            }
            if (null === nextStep && index >= array.length - 1) {
                nextStep = 'design';
            }
            return true;
        });

        if ('design' === nextStep) {
            this.setDesignerClass();
            let variantResult = this.selectVariant();

            if (false === variantResult) {
                return;
            }
            const textDesigner = this.node.querySelector('.step.step-design.product-patch.pattern-text .substep-patch');
            if (textDesigner) {
                this.patchEditor = new PatchEditor(this.node);
            }
        }

        this.node.querySelectorAll('.substep:not(.d-none)').forEach((node) => {
            node.classList.add('d-none');
        });
        this.node.querySelectorAll('.step:not(.d-none)').forEach((node) => {
            node.classList.add('d-none');
        });

        let nextStepNode = this.node.querySelector('.step.step-' + nextStep);

        if (nextStepNode) {
            nextStepNode.classList.remove('d-none');
            let subStepSelector = '.substep.substep-' + this.choices['product'];
            let nextSubStepNode = nextStepNode.querySelector(subStepSelector);
            if (nextSubStepNode) {
                nextSubStepNode.classList.remove('d-none');
            }

            this.setTitle();
            if ('design' === nextStep) {
                if(0 < this.stoneValues.length){
                    this.loadStones();
                }
                this.saveStones();
            }
        }
    }

    setTitle() {
        let title = this.node.querySelector('.substep:not(.d-none) h2');
        if (null === title) {
            title = this.node.querySelector('.step:not(.d-none) h2');
        }
        if (title) {
            this.node.querySelector('.steptitle').textContent = title.textContent;
            title.classList.add('d-none')
        }
    }

    setDesignerClass() {
        const designer = this.node.querySelector('.step.step-design');
        designer.className = designer.dataset.emptyClass;

        for (const [key, value] of Object.entries(this.choices)) {
            designer.className += `${key}-${value} `;
        }

        if (this.choices['product'] in this.preselectedProductValues) {
            for (const [key, value] of Object.entries(this.preselectedProductValues[this.choices['product']])) {
                designer.className += `${key}-${value} `;
            }
        }
    }

    selectStone(stoneNode) {
        if (true === stoneNode.classList.contains('active')) {
            stoneNode.classList.remove('active');
            this.selectedStone = null;

            return;
        }

        let stoneUrl = stoneNode.querySelector('img').src;

        this.selectedStone = {
            id: stoneNode.dataset.stoneId,
            url: stoneUrl,
            enable_large: 'true' === stoneNode.dataset.enableLarge,
            enable_small: 'true' === stoneNode.dataset.enableSmall
        };

        this.node.querySelector('.current-selection>img').src = stoneUrl;
        this.node.querySelector('.current-selection').classList.remove('d-none');

        stoneNode
            .closest('.stone_switch')
            .querySelectorAll('.stone.active')
            .forEach((activeStone) => {
                activeStone.classList.remove('active');
            });

        stoneNode.classList.add('active');
    }

    saveStones() {
        const stones = this.node.querySelectorAll('.step-design .substep:not(.d-none) .stone-slot');
        this.stoneValues = [];
        for (let [key, stone] of stones.entries()) {
            if ('block' !== window.getComputedStyle(stone).display) {
                break; //do not iterate over all those invisible stones
            }
            this.stoneValues.push(stone.dataset.stoneId);
        }
        if (0 >= this.stoneValues.length && null !== this.patchEditor) {
            this.stoneValues = this.patchEditor.getStones();
        }
        this.updateUrlStones()
        let stringArray = this.chunkSubstr(this.stoneValues.join('x'), 255);

        stringArray.forEach((stoneSubString, key) => {
            this.node.querySelector('form.add-to-cart input#stones_' + (key + 1)).value = stoneSubString;
        });
    }

    loadStones() {
        const stones = this.node.querySelectorAll('.step-design .substep:not(.d-none) .stone-slot');
        for (let [key, stone] of stones.entries()) {
            if ('block' !== window.getComputedStyle(stone).display) {
                break; //do not iterate over all those invisible stones
            }
            if (typeof (this.stoneValues[key]) === 'undefined') {
                break;
            }
            stone.dataset.stoneId =  this.stoneValues[key];

            const url = document.querySelector('.stone[data-stone-id="'+parseInt(this.stoneValues[key])+'"] > img')?.src;
            if (true === stone.hasAttribute('href')) {
                stoneSlotNode.setAttribute('href', url);
            } else {
                stone.style.backgroundImage = 'url("' + url + '")';
            }
        }
    }

    placeStone(stoneSlotNode) {
        if (typeof (this.selectedStone) === 'undefined' || null === this.selectedStone) {
            return;
        }

        if(true !== this.checkStonePlacement(stoneSlotNode)) {
            return;
        }

        if (true === stoneSlotNode.hasAttribute('href')) {
            stoneSlotNode.setAttribute('href', this.selectedStone.url);
        } else {
            stoneSlotNode.style.backgroundImage = 'url("' + this.selectedStone.url + '")';
        }
        stoneSlotNode.dataset.stoneId = this.selectedStone.id;

        this.saveStones();
    }

    checkStonePlacement(stoneSlotNode) {
        if (stoneSlotNode.offsetWidth > 40 && true === this.selectedStone.enable_large) {
            return true;
        }

        if (stoneSlotNode.offsetWidth <= 40 && true === this.selectedStone.enable_small) {
            return true;
        }

        let modal = this.node.querySelector('#configurator-alert').content.cloneNode(true);

        modal.querySelector('.current-selection img').setAttribute('src', this.selectedStone.url);

        modal.querySelector('.modal').addEventListener('click', event => {

            const domModal = this.node.closest('body').querySelector('.configurator-alert');

            let target = event.target.closest('.accept');
            if (null !== target) {
                domModal.remove();
            }
        });

        this.node.closest('body').appendChild(modal);

        return false;
    }

    resetStones() {
        let blankUrl = this.node.querySelector('#inlay-stones .stone:first-child img').src;
        this.node.querySelectorAll('.stone-slot-trigger').forEach((slotNode) => {
            slotNode.dataset.stoneId = '01';
            if (true === slotNode.hasAttribute('href')) {
                slotNode.setAttribute('href', blankUrl);
            } else {
                slotNode.style.backgroundImage = null;
            }
        });
        this.saveStones();
    }

    createBreadcrumbs() {
        let breadCrumbContainer = this.node.querySelector('#confi_breadcrumb');
        breadCrumbContainer.innerHTML = '';
        for (const [key, value] of Object.entries(this.choices)) {
            let breadCrumbElement = document.createElement('div');
            breadCrumbElement.classList.add('breadcrumb');
            breadCrumbElement.dataset.key = key;
            breadCrumbElement.dataset.value = value;
            breadCrumbElement.innerHTML = this.translations[key] + ': <span class="breadcrumb-value">' + this.translations[value] + '</span>';

            breadCrumbContainer.appendChild(breadCrumbElement);
        }
    }

    createUrl(){
        history.pushState(null, null, window.location.pathname);
        const searchParams = new URLSearchParams();

        for (const key in this.choices) {
            searchParams.append(key, this.choices[key]);
        }
        const baseUrl = window.location.origin;
        let url = `${baseUrl}${window.location.pathname}`;
        const stringParams = searchParams.toString();
        if(0 < stringParams.length){
            url += `?${stringParams}`;
        }

        history.pushState(null, null, url);
    }

    updateUrlStones(){
        const queryParams = new URLSearchParams(window.location.search);

        queryParams.set('stones', this.stoneValues.join('x'));

        const baseUrl = window.location.origin;
        const url = `${baseUrl}${window.location.pathname}?${queryParams.toString()}`;

        history.pushState(null, null, url);
    }

    selectVariant() {
        let amount = 1;
        let productString = '';

        const combinedChoices = {...this.choices, ...this.preselectedProductValues[this.choices['product']]};

        if (['dogcollar', 'belt', 'bracelet', 'saddlestrap'].includes(combinedChoices['product'])) {
            productString += 'inlay';
        } else {
            productString += combinedChoices['product'];
        }

        if (['patch', 'crystalnet'].includes(combinedChoices['product'])) {
            productString += '-' + combinedChoices['product-color'];
        } else {
            productString += '-' + combinedChoices['style'];
            productString += '-' + combinedChoices['size'];
        }

        if ('pattern' in combinedChoices) {
            productString += '-' + combinedChoices['pattern'];
        }

        if (['belt'].includes(combinedChoices['product'])) {
            amount = 2;
        }
        const option = this.node.querySelector('form.add-to-cart select.variant option.' + productString);
        if (null === option) {
            console.error('selected variant "' + productString + '" not found');

            return false;
        }
        this.node.querySelector('.product__price').innerHTML = option.dataset.price;
        this.node.querySelector('form.add-to-cart input#Quantity').value = amount;
        this.node.querySelector('form.add-to-cart select.variant').value = option.value;
    }

    //TODO: Rework that. fucking copy&paste
    chunkSubstr(str, size) {
        const numChunks = Math.ceil(str.length / size);
        const chunks = new Array(numChunks);

        for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
            chunks[i] = str.substr(o, size);
        }

        return chunks;
    }

    reset() {
        this.choices = {};
        this.selectedStone = null;
        this.resetStones();
        this.createBreadcrumbs();
        this.createUrl();

        this.node.querySelectorAll('.step').forEach((node) => {
            node.classList.add('d-none');
        });

        this.node.querySelectorAll('.substep').forEach((node) => {
            node.classList.add('d-none');
        });

        this.node.querySelector('.step.step-product').classList.remove('d-none');

        this.setTitle();

        this.node.querySelector('.current-selection').classList.add('d-none');
        this.node.querySelector('.current-selection>img').src = '';
    }
}
